import { conductCheckSignals } from "../../../constants";
import { getScreeningOutcomeItems } from "../../../helpers"

export const getConductCheckData = (contentData) => {
  return {
    badActors: getScreeningOutcomeItems(contentData, "conductCheck.badActors"),
  };
};

export const formatScreeningOutcomeHits = (screeningOutcomes) => {
  if (!screeningOutcomes) return null;
  const labelMap = conductCheckSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label}&nbsp;(x${items.length})` : null;
    })
    .join("<br>");

  return formattedStatus;
};

export const formatScreeningOutcomeHitsPlainText = (screeningOutcomes) => {
  if (!screeningOutcomes) return "";
  const labelMap = conductCheckSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label} (x${items.length})` : null;
    })
    .filter(Boolean)
    .join("\n");

  return formattedStatus;
};
